import React from "react";
import { CloseIcon } from "../../../assets/icons";
import FileDisplay from "../../../utils/FileDisplay";
import NuDateFormat from "../../../utils/NuDate";
import { ViewLabelwithDataBg } from "../../../components/View/ViewLabelwithData";

function ViewMaintenance({ visible, onClose, data }) {
  if (!visible) return null;

  return (
    <div
      id="modal"
      className="bg-black bg-opacity-30 fixed inset-0 backdrop-blur-sm 
  flex justify-center items-center z-10"
    >
      <div className="bg-white p-2 rounded w-10/12 max-h-[calc(100vh-80px)] overflow-hidden">
        <div className="flex items-start justify-between px-5 py-2  rounded-t">
          <h3 className="text-base 2xl:text-xl capitalize font-semibold">
           {data?.task + " View" || "Maintenance View"}
          </h3>
          <span
            className="h-6 w-6 text-2xl block cursor-pointer"
            onClick={onClose}
          >
            <CloseIcon />
          </span>
        </div>
        <div className="overflow-y-auto max-h-[calc(100vh-140px)]">
          <div>
            <ViewLabelwithDataBg title="Maintenance Task" value={data?.task || "-"} />
            <ViewLabelwithDataBg title="Frequency" value={data?.frequency_name || "-"} />
            <ViewLabelwithDataBg title="Status" value={data?.status_id || "-"} />
            <ViewLabelwithDataBg title="Comments" value={data?.comments || "-"} />
            <div className="my-3 text-left">
              <p className="text-sm text-[#1D1818] font-semibold mb-1 pl-8">
              Artefact
              </p>
              <div className=" w-full flex flex-wrap">
                {data?.file_path &&
                  data?.file_path.map((i) => {
                    return (
                      <div className=" m-1">
                        <FileDisplay data={i} view={true} height={"45px"} width={"45px"} />
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewMaintenance;
